import { atom } from "jotai";

export type ActiveButtonType =
  | "color"
  | "app"
  | "link"
  | "note"
  | "actor"
  | "zap steps"
  | "more";

export const floatingToolbarActiveButtonAtom = atom<ActiveButtonType | null>(
  null,
);

floatingToolbarActiveButtonAtom.debugLabel = "floatingToolbarActiveButtonAtom";
